import { render, staticRenderFns } from "./TaskDetailsListModal.vue?vue&type=template&id=6ed5a197&scoped=true&"
import script from "./TaskDetailsListModal.vue?vue&type=script&lang=ts&"
export * from "./TaskDetailsListModal.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDetailsListModal.vue?vue&type=style&index=0&id=6ed5a197&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed5a197",
  null
  
)

export default component.exports